import { render, staticRenderFns } from "./PBIcons.vue?vue&type=template&id=5092e91c&"
import script from "./PBIcons.vue?vue&type=script&lang=js&"
export * from "./PBIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports